/**
 PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA

 *  Copyright © 2017 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider, injectIntl } from 'react-intl';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CancelLg from '../../icons/CancelLg';
import HeaderStyles from './HeaderStyles';
import Utilities from '../../util/Utilities';
import msgObject from '../../../../translations';
import IntlSupport from '../Localization/InternationalSupport';

const Header = (props) => {
  const { userPreference } = props;
  let iconColor = '#636769';
  if (userPreference) {
    const { theme } = userPreference;
    iconColor = (theme === 'Black') ? '#fff' : '#636769';
  }

  const intlObj = new IntlSupport(msgObject, props.intl.locale);
  // if closeBtnText provided then it will display that text other wise default close text to apply aria-label
  // the closeBtnText prop value should be pass as localizated text
  const buttonText = props.closeBtnText ? props.closeBtnText : intlObj.getMessages().closeButtonText;
  let header = null;
  if (props.displayTitle || props.title || props.children) {
    header = (
      <AppBar
        position="static"
        style={HeaderStyles.modalHeader}
        className={`${props.isFixedHeader ? 'fixed-header modal-header' : 'modal-header'}`}
      >
        <Toolbar style={HeaderStyles.toolBar}>
          <span>{' '}</span>
          <Typography variant="h2" style={HeaderStyles.title}>
            {props.displayTitle ? Utilities.textFromContent(props.displayTitle) : props.title}
          </Typography>
          <div className="header-controls">
            {props.children}
            <IconButton
              aria-label={buttonText}
              style={HeaderStyles.closeBtn}
              className="header-close-btn"
              onClick={props.onClose}
            >
              <CancelLg fillColor={iconColor} />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
    );
  } else if (props.isFloatingHeader) {
    header = (
      <div
        className={`${props.isFixedHeader ? 'fixed-header modal-header std-close-btn' : 'modal-header std-close-btn'}`}
      >
        <IconButton
          aria-label={buttonText}
          style={HeaderStyles.headerCloseBtn}
          className="header-close-btn"
          onClick={props.onClose}
        >
          <CancelLg fillColor={iconColor} />
        </IconButton>
      </div>
    );
  } else {
    header = (
      <AppBar
        position="static"
        style={HeaderStyles.modalHeader}
        className={`${props.isFixedHeader ? 'fixed-header modal-header close-btn' : 'modal-header close-btn'}`}
      >
        <Toolbar style={HeaderStyles.toolBar}>
          <span>{' '}</span>
          <Typography variant="h2" style={HeaderStyles.title}>
            <span />
          </Typography>
          <IconButton
            aria-label={buttonText}
            style={HeaderStyles.headerCloseBtn}
            className="header-close-btn"
            onClick={props.onClose}
          >
            <CancelLg fillColor={iconColor} />
          </IconButton>
        </Toolbar>
      </AppBar>
    );
  }

  return (
    <IntlProvider locale={intlObj.getLocale()} messages={intlObj.getMessages()}>
      {header}
    </IntlProvider>);
};

/**
 * displayTitle -->> To display MathML
 * children -->> To display controls
 * isFixedHeader -->> To set fixed or moviable header
 * isFloatingHeader -->> To set only close button without header space
* */
Header.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object
  ]),
  displayTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object
  ]),
  onClose: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]),
  isFixedHeader: PropTypes.bool,
  isFloatingHeader: PropTypes.bool,
  closeBtnText: PropTypes.string,
  intl: PropTypes.object,
  userPreference: PropTypes.object
};

export default injectIntl(Header);



// WEBPACK FOOTER //
// ./src/js/components/Header/Header.jsx